import { t } from 'ember-intl';
import { lowercase } from 'ember-cli-string-helpers';
import { LayoutLoading } from 'core/components';

<template>
  <LayoutLoading class="layout--with-sidebar">
    <LayoutLoading as |L|>
      <L.Message>
        {{t
          "components.layout.loading.loading-page-name"
          pageName=(lowercase
            (t "components.page.access-control.users.list.title")
          )
        }}
      </L.Message>
    </LayoutLoading>
  </LayoutLoading>
</template>
